/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Use MUI's standard Card styling with minimal overrides
export default {
  defaultProps: {
    elevation: 1, // Subtle elevation for softer look
  },
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.background.paper,
      // Soften the shadow for a more refined look
      boxShadow:
        theme.palette.mode === "dark"
          ? "0 2px 8px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.05)"
          : "0 1px 4px rgba(0, 0, 0, 0.08)",
      // Optional: add subtle border in dark mode
      ...(theme.palette.mode === "dark" && {
        border: "1px solid rgba(255, 255, 255, 0.08)",
      }),
    }),
  },
};
